import axios from '../Backend';

export const getInquiriesForSpecificContactPerson = async (contactId, msgType, sort, agentName, startDate, status) => {
    try {
        let url = `/api/v2/contacts/${contactId}/inquiries`;

        let params = [];
        if (msgType) {
            params.push(`msgType=${msgType}`);
        }

        if (sort) {
            params.push(`sort=${sort}`);
        }

        if (agentName) {
            params.push(`answerAgent.agentName=${agentName}`);
        }

        if (startDate) {
            params.push(`startTime[gt]=${startDate.toISOString()}`);
        }

        if (status) {
            params.push(`status=${status}`);
        }

        if (params.length) {
            url += `?${params.join('&')}`;
        }

        const response = await axios.get(url);
        return response.data;
    } catch (e) {
        console.error('Error fetching inquiries:', e?.response?.data);
        return null;
    }
}